import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.138.195a.667.667 0 1 0-.943.943L3.72 4.663l-.387.671c0 2.235-.478 3.623-.918 4.43a4 4 0 0 1-.586.83 2 2 0 0 1-.205.189h-.002A.667.667 0 0 0 2 12h9.057l3.805 3.805a.667.667 0 1 0 .943-.943L4.653 3.71l-.017-.017zm3.526 5.412c-.037 2.28-.54 3.809-1.079 4.796q-.075.139-.152.264h6.29z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.775.666a4.666 4.666 0 0 1 4.892 4.668v.018a11.3 11.3 0 0 0 .396 3.139.667.667 0 0 1-1.286.351 12.6 12.6 0 0 1-.444-3.517 3.334 3.334 0 0 0-5.183-2.77.667.667 0 1 1-.74-1.11A4.67 4.67 0 0 1 7.775.666M6.512 13.423a.667.667 0 0 1 .911.242.667.667 0 0 0 1.154 0 .667.667 0 1 1 1.153.67 2 2 0 0 1-3.46 0 .667.667 0 0 1 .242-.912"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })